import math from "core/math";
import path from "./path.js";

/**
 * Draw a series of joined lines, starting at `start` and then going to each point in `points`.
 * @public
 * @method drawJoinedLines
 * @memberof Drawing
 *
 * @param {CanvasRenderingContext2D} context - Target context
 * @param {HTMLElement} element - The DOM Element to draw on
 * @param {Object} start - `{ x, y }` in either pixel or canvas coordinates.
 * @param {Object[]} points - `[{ x, y }]` An array of points in either pixel or canvas coordinates.
 * @param {Object} options - See {@link path}
 * @param {String} [coordSystem='pixel'] 
 * @returns {undefined}
 */
export default function(
  context,
  element,
  start,
  points,
  options,
  coordSystem = "pixel"
) {
  path(context, options, context => {
    if (coordSystem === "pixel") {
      start = math.coordinate.pixelToCanvas(element, start);
      points = points.map(p => math.coordinate.pixelToCanvas(element, p));
    }
    context.moveTo(start.x, start.y);
    points.forEach(({ x, y }) => {
      context.lineTo(x, y);
    });
  });
}
